import * as React from 'react';
import { Colors, LinkText, Text } from '@origin-digital/style-guide';
import styled from 'styled-components';
import { hideCaptchaBadge } from '../../../../../styles';

hideCaptchaBadge();

const CaptchaSection: React.FC<{}> = () => {
  return (
    <CaptchaText data-id="captcha-text">
      This site is protected by reCAPTCHA and the Google&nbsp;
      <CaptchaLink
        data-id="captcha-link1"
        target="_blank"
        text="Privacy Policy"
        href="https://policies.google.com/privacy"
      />
      &nbsp;and&nbsp;
      <CaptchaLink
        target="_blank"
        data-id="captcha-link2"
        href="https://policies.google.com/terms"
        text="Terms of Service"
      />
      &nbsp;apply.
    </CaptchaText>
  );
};

export { CaptchaSection };

const CaptchaText = styled(Text)`
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: ${Colors.GREY48};
  hyphens: manual;
`;

const CaptchaLink = styled(LinkText)`
  hyphens: manual;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.7;
  color: ${Colors.GREY48};
  align-items: center;
  text-decoration: underline;
  &:hover,
  &:active,
  &:visited {
    color: ${Colors.GREY48};
    text-decoration: underline;
  }
`;
